import { useEffect, useRef } from 'react';
import mermaid from 'mermaid';

const MermaidRenderer = ({ data, config = {} }) => {
  const containerRef = useRef();

  useEffect(() => {
    mermaid.initialize({
      startOnLoad: true,
      theme: 'default',
      securityLevel: 'loose',
      fontFamily: 'Arial, sans-serif',
    });
  }, []);

  useEffect(() => {
    if (!data || !containerRef.current) return;

    // Clear previous
    containerRef.current.innerHTML = '';

    // Create mermaid div
    const mermaidDiv = document.createElement('div');
    mermaidDiv.className = 'mermaid';
    mermaidDiv.textContent = typeof data === 'string' ? data : data.code;
    
    containerRef.current.appendChild(mermaidDiv);

    // Render
    mermaid.contentLoaded();
  }, [data]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
      <div 
        ref={containerRef} 
        style={{ 
          padding: '20px',
          background: 'white',
          borderRadius: '4px',
          maxWidth: '100%'
        }} 
      />
    </div>
  );
};

export default MermaidRenderer;
